import React from 'react'

const DefaultPage = () => {
    return (
        <div className='w-full h-[100vh] flex justify-center items-center'>
            You Broke Something
        </div>
    )
}

export default DefaultPage